module.exports = __webpack_public_path__ + "img/1476838946.23d1ee02.jpg";